import { useEnvironmentInterface } from "environment-interface";

import { useAnalytics } from "hooks/useAnalytics";

import type { Command } from "../../types";

export const useOpenEditorSettingsCommand = (
  event_source: "main_menu" | "ui",
): Command => {
  const { monacoEditor } = useEnvironmentInterface();
  const track = useAnalytics();

  return {
    id: "workbench.action.openSettings",
    name: "User Preferences",
    section: "Preferences",
    binding: "$mod+,",
    perform: async () => {
      track("open_editor_settings", { event_source });
      const vscodeApi = await monacoEditor.getExtensionApi();
      vscodeApi.commands.executeCommand("workbench.action.openSettings");
    },
  };
};
